var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFiinGroupEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 441.88 96.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #034ea2;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        fill: #50a4db;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.62,39.43c3.84,6.54,12.67,4.68,19.11,4.03-.57,1.22-1.29,2.39-1.97,3.55-.96,1.65-1.92,1.37-3.71,1.53-3.02.27-6.1.45-9.12.02-2.29-.33-5.05-1.06-6.24-3.24-1.16-2.12-.22-4.81,1.92-5.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.66,36.53s-6.57.72-11.16.72-7.01-2.39-7.01-5.62,2.87-6.42,7.47-6.42c6.08,0,14.43,4.74,14.43,4.74l-3.72,6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.42,48.07s8.67-.83,11.62-.83,9.69,1.48,9.69,7.15c0,6.7-12.2,11.06-12.2,11.06l6.81,1.8s9.91-5.58,9.91-13.27-7.03-11.38-13.54-11.38-9.61.68-9.61.68l-2.68,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.29,55.13l-3.12,5.5s5.8,1.19,13.07,3.94c0,0,8.68-3.55,8.68-7.72,0-2.17-2.21-2.86-3.78-2.86s-14.84,1.14-14.84,1.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.87,68.78c-7.14-2.51-20.21-5.1-20.21.42s14.26,3.36,20.21-.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.12,6.58C25.22,6.58,6.66,25.14,6.66,48.04s18.56,41.46,41.46,41.46,41.46-18.56,41.46-41.46S71.02,6.58,48.12,6.58M56.88,73.07l-9.74-3.21s-26.95,12.29-26.95-2.61c0-10.24,18.03-6.99,18.03-6.99l2.4-4.93s-19.28,2.88-19.28-8.86c0-7.29,7.09-8.93,7.09-8.93,0-9.53,14.22-19.06,14.22-19.06l16.28,5.43,2.53-4.43,1.9,1.03-9.4,15.91s24.98-2.97,24.98,12.39c0,17.19-22.06,24.25-22.06,24.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.2,96.4C21.62,96.4,0,74.78,0,48.2S21.62,0,48.2,0s48.2,21.62,48.2,48.2-21.62,48.2-48.2,48.2M48.2,3.66C23.64,3.66,3.66,23.64,3.66,48.2s19.98,44.54,44.54,44.54,44.54-19.98,44.54-44.54S72.76,3.66,48.2,3.66"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.93,74.18h9.15v1.93h-6.91v4.21h6.55v1.88h-6.55v4.48h6.91v1.93h-9.15v-14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.13,74.18h2.07l7.41,10.66h.06v-10.66h2.22v14.42h-2.06l-7.42-10.68h-.06v10.68h-2.22v-14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.3,74.18h2.24v12.49h6.72v1.93h-8.95v-14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.92,74.18h2.24v14.42h-2.24v-14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.04,81.32h0c0-4.56,2.6-7.38,6.69-7.38,3.38,0,5.5,1.95,6.1,4.55l.04.18h-2.3l-.03-.11c-.61-1.67-1.92-2.64-3.8-2.64-2.76,0-4.43,2.01-4.43,5.39h0c0,3.46,1.72,5.56,4.47,5.56,2.34,0,3.96-1.48,3.99-3.67v-.24h-3.79v-1.83h6v1.48c0,3.91-2.31,6.24-6.22,6.24-4.13,0-6.73-2.88-6.73-7.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.92,74.18h2.24v6.1h7.41v-6.1h2.24v14.42h-2.24v-6.39h-7.41v6.39h-2.24v-14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.77,76.11h-4.42v-1.93h11.06v1.93h-4.41v12.49h-2.24v-12.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.99,74.18h9.15v1.93h-6.91v4.21h6.55v1.88h-6.55v4.48h6.91v1.93h-9.15v-14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.19,74.18h2.07l7.41,10.66h.06v-10.66h2.22v14.42h-2.06l-7.42-10.68h-.06v10.68h-2.22v-14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.82,76.11h-4.42v-1.93h11.06v1.93h-4.41v12.49h-2.24v-12.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.03,74.18h2.24v6.1h7.41v-6.1h2.24v14.42h-2.24v-6.39h-7.41v6.39h-2.24v-14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.31,74.18h9.15v1.93h-6.91v4.21h6.55v1.88h-6.55v4.48h6.91v1.93h-9.15v-14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.4,74.18h2.59l4.67,11.51h.06l4.68-11.51h2.58v14.42h-2.04v-10.64h-.07l-4.35,10.64h-1.66l-4.35-10.64h-.07v10.64h-2.04v-14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.56,74.18h2.42l5.24,14.42h-2.35l-1.32-3.9h-5.56l-1.33,3.9h-2.35l5.25-14.42ZM317.59,82.9h4.35l-2.15-6.34h-.04l-2.16,6.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.55,74.18h5.6c2.95,0,4.81,1.71,4.81,4.42v.02c0,1.96-1.07,3.52-2.8,4.11l3.23,5.88h-2.58l-2.94-5.54h-3.08v5.54h-2.24v-14.42ZM334.93,81.22c1.73,0,2.72-.95,2.72-2.59v-.02c0-1.6-1.06-2.56-2.78-2.56h-3.08v5.17h3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.86,74.18h2.24v6.91h.06l5.82-6.91h2.66l-5.47,6.38,5.94,8.04h-2.77l-4.77-6.52-1.47,1.7v4.82h-2.24v-14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.29,74.18h9.15v1.93h-6.91v4.21h6.55v1.88h-6.55v4.48h6.91v1.93h-9.15v-14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.07,76.11h-4.42v-1.93h11.06v1.93h-4.41v12.49h-2.24v-12.49Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.93,8.45h33.38v8.8h-22.71v13.67h20.73v8.44h-20.73v20.06h-10.67V8.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "155.34 24.24 165.65 21.55 165.65 59.42 155.34 59.42 155.34 24.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "171.69 24.24 182 21.55 182 59.42 171.69 59.42 171.69 24.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.34,33.77v-.03c0-16.32,9.36-26.17,24.3-26.17,12.26,0,20.59,7.13,22.29,16.71l.11.49h-10.7l-.14-.35c-1.7-4.94-5.76-7.81-11.52-7.81-8.41,0-13.46,6.22-13.46,17.02v.04c0,11.06,5.37,17.59,13.85,17.59,6.96,0,11.73-4.13,12.01-10.42l.04-.74h-11.66v-7.95h22.04v5.86c0,13.88-8.41,22.29-22.61,22.29-15.22,0-24.55-9.93-24.55-26.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.25,21.55h10.31v6.61h.21c1.13-4.66,4.2-7.38,8.62-7.38,1.13,0,2.19.18,2.97.39v9.08c-.85-.35-2.26-.57-3.74-.57-5.09,0-8.05,3.04-8.05,8.55v21.19h-10.31V21.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.38,40.48v-.07c0-12.19,7.42-19.64,18.72-19.64s18.79,7.38,18.79,19.64v.07c0,12.36-7.31,19.71-18.76,19.71s-18.76-7.38-18.76-19.71ZM331.4,40.48v-.07c0-7.31-3.28-11.55-8.3-11.55s-8.23,4.24-8.23,11.55v.07c0,7.42,3.21,11.62,8.3,11.62s8.23-4.24,8.23-11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.57,45.99v-24.44h10.31v22.29c0,4.95,2.33,7.81,6.96,7.81s7.56-3.39,7.56-8.34v-21.76h10.31v37.87h-10.31v-7.39h-.21c-1.94,4.35-5.83,8.16-11.55,8.16-8.34,0-13.07-5.33-13.07-14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.18,34.97v24.44h-10.31v-22.29c0-4.95-2.33-7.81-6.96-7.81s-7.56,3.39-7.56,8.34v21.76h-10.31V24.24l10.31-2.69v7.39h.21c1.94-4.35,5.83-8.16,11.55-8.16,8.34,0,13.07,5.33,13.07,14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388.37,21.55h10.31v6.61h.25c2.05-4.59,6.18-7.38,11.55-7.38,9.61,0,15.47,7.35,15.47,19.68v.03c0,12.29-5.86,19.71-15.33,19.71-5.4,0-9.68-2.75-11.73-7.24h-.21v18.83h-10.31V21.55ZM415.46,40.48v-.03c0-6.92-3.25-11.13-8.37-11.13s-8.44,4.31-8.44,11.16v.04c0,6.82,3.43,11.13,8.44,11.13s8.37-4.27,8.37-11.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "182 17.24 171.69 19.93 171.69 11.14 182 8.45 182 17.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "165.65 17.24 155.34 19.93 155.34 11.14 165.65 8.45 165.65 17.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.93,7.56c3.68,0,6.96,2.58,6.96,6.6s-3.28,6.61-6.96,6.61-6.96-2.56-6.96-6.61,3.28-6.6,6.96-6.6ZM434.93,19.38c2.81,0,5.11-2.19,5.11-5.22s-2.3-5.18-5.11-5.18-5.11,2.17-5.11,5.18,2.26,5.22,5.11,5.22ZM435.09,10.45c1.9,0,2.97.58,2.97,2.19,0,1.36-.89,1.89-1.99,1.98l2.03,3.24h-1.58l-1.85-3.17h-.94v3.17h-1.5v-7.41h2.86ZM435.07,13.54c.87,0,1.49-.12,1.49-1.03,0-.78-.87-.92-1.56-.92h-1.27v1.94h1.34Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFiinGroupEn);
export default __webpack_public_path__ + "static/media/logoFiinGroupEN.aff95ad8232c3b46861e98c78337fb80.svg";
export { ForwardRef as ReactComponent };